<template>
  <div>
    <div class="header f-c-b" :class="(op * 1 > 0.6) ? 'active' : ''">
      <div class="logo" @click="routerPush('/')">
        <img src="../assets/images/logo_header.png">
      </div>
      <div class="f-c-c" v-if="op * 1 > 0.6 && !isNavZd">
        <div class="nav-item" :class="title === item.title ? 'nav-item-active' : ''" v-for="(item, index) in navList" :key="index" @click="routerPush(item.path)">{{item.title}}</div>
      </div>
      <div class="f-c-c" v-else>
          <div class="f-c-c c-p" @click="clickRightMenu">
            <i v-if="headerDrawerShow === true" class="el-icon-s-unfold font-32 c-theme"></i>
            <i v-if="headerDrawerShow === false" class="el-icon-s-fold  font-32 c-theme"></i>
          </div>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div class="drawer-mask" v-if="headerDrawerShow && (op * 1 < 0.6 || isNavZd)" @click="headerDrawerShow = false">
        <div class="my-drawer" @click.stop>
          <div class="drawer-item" v-for="(item, index) in navList" :class="title === item.title ? 'drawer-item-active' : ''" :key="index" @click="routerPush(item.path)">{{item.title}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    op: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isNavZd: false, // 小屏幕下是否折叠菜单
      headerShow: false, // nav显示与否
      curNav: '', // 当前nav
      navList: [
        { title: '首页', path: '/' },
        { title: '资讯动态', path: '/news' },
        { title: '经典案例', path: '/projects' },
        { title: '核心团队', path: '/teamcore' },
        { title: '设计部门', path: '/designbranch' },
        { title: '项目管理', path: '/strategy' },
        { title: '招聘求职', path: '/positionlist' },
        { title: '关于我们', path: '/about' },
        { title: '联系我们', path: '/contact' }
      ], // 菜单数组
      headerDrawerShow: false // nav抽屉展示与否
    }
  },
  mounted () {
    const _this = this
    this.$nextTick(() => {
      _this.seeClientWidth()
    })
    window.onresize = function () {
      _this.seeClientWidth()
    }
  },
  methods: {
    routerPush (path) {
      if (path === '/login') {
        window.open(this.$com.login)
      } else {
        const curPath = this.$route.path
        if (path !== curPath) {
          this.$router.push({ path: path })
        }
      }
    },
    seeClientWidth () {
      const width = document.documentElement.clientWidth
      if (width < 1000) {
        this.isNavZd = true
      } else {
        this.isNavZd = false
      }
    },
    // 小屏幕下点击右侧菜单折叠按钮
    clickRightMenu () {
      this.headerDrawerShow = !this.headerDrawerShow
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header{
    height: 60px;
    position: fixed;
    top: 0;
    z-index: 100;
    color: #fff;
    &:hover{
      /*background-color: #ffffff;*/
      /*color: #8c8c8c;*/
    }
    .logo img{
      cursor: pointer;
      /*width: 40px;*/
    }
    .nav-item{
      padding: 0 16px;
      font-size: 17px;
      cursor: pointer;
      &:hover, &-active{
        font-weight: 700;
        font-size: 20px;
        color: #000000;
      }
    }
  }
  .active {
    color: #8c8c8c;
    -webkit-animation: animation-to-white .5s;
    animation: animation-to-white .5s;
    background-color: #ffffff;
    .logo{
      color: #000000;
    }
  }
  .pc-menu {
    padding: 20px 30px 20px 0;
    &-item{
      padding: 10px 20px;
      color: #8c8c8c;
      cursor: pointer;
      &:hover, &-active{
        font-weight: 700;
        color: #000000;
      }
    }
  }
  .sub-header{
    position: fixed;
    top: 50px;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #333333;
    z-index: 100;
  }
  .drawer-mask{
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    /*background-color: rgba(0, 0, 0, 0.3);*/
    z-index: 98;
  }
  .my-drawer{
    position: absolute;
    right: 0;
    top: 0;
    overflow: auto;
    text-align: right;
    background-color: white;
    z-index: 99;
    .drawer-item{
      padding: 10px 0;
      font-size: 17px;
      cursor: pointer;
      color: #8c8c8c;
      &:hover, &-active{
        font-weight: 700;
        font-size: 20px;
        color: #000000;
      }
    }
  }
  @media (min-width: 1024px) {
    .header {
      height: 90px;
      padding: 0 64px;
      width: calc(100% - 128px);
      .logo img{
        width: 50px;
      }
    }
    .my-drawer{
      padding: 90px 64px 20px 64px;
      height: calc(100vh - 110px);
      /*width: calc(100% - 128px);*/
    }
    .sub-header{
      top: 80px;
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .header {
      padding: 0 20px;
      width: calc(100% - 40px);
      .logo img{
        width: 40px;
      }
    }
    .my-drawer{
      padding: 90px 20px 20px 20px;
      /*width: calc(100% - 40px);*/
      height: calc(100vh - 110px);
    }
  }
  @media (max-width: 767px) {
    .header {
      padding: 0 10px;
      width: calc(100% - 20px);
      .logo img{
        width: 40px;
      }
    }
    .my-drawer{
      padding: 90px 20px 20px 20px;
      height: calc(100vh - 110px);
      background-color: rgba(0, 0, 0, 0.3);
      width: calc(100% - 40px);
      .drawer-item{
        color: #ffffff;
        &:hover, &-active{
          font-weight: 700;
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
  }
</style>
